import * as React from 'react';
import { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

function ProductsPropertiesChangedInfoModal(props: {
    open: boolean,
    onClose: () => void
}) {

    return <Modal backdrop={'static'} isOpen={props.open} toggle={props.onClose} size="md">
        <ModalHeader className="modal-header">
            <h5 className="modal-title">Products Update Notice</h5>
        </ModalHeader>
        <ModalBody>
            <div className="text-center">
                <div className="lead"><span>One or more products have been updated.</span></div>
            </div>
        </ModalBody>
        <ModalFooter>
            <div className="w-100 d-flex">
                <Button color="white" className="btn btn-black d-inline-block border flex-fill"
                    onClick={props.onClose}>Ok</Button>
            </div>
        </ModalFooter>
    </Modal>
}

export default ProductsPropertiesChangedInfoModal;
